module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 589
// module chunks = 0